// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
export type TubeDataFromSessionFragment = { __typename?: 'TubeDataFromSession', data: Array<{ __typename?: 'TubeSessionData', isOverridden?: boolean | null, name?: string | null, sequence?: string | null, minimumYield?: string | null, epsilon?: number | null, fiveMod?: string | null, threeMod?: string | null, internalMod?: string | null, probeType?: string | null, purification?: string | null, baseCount?: number | null, format?: string | null, scale?: string | null, concentration?: string | null, tubes?: string | null, price?: string | null, orderItemId?: string | null, id?: string | null, applyToAll?: boolean | null, comments?: string | null, additionalComments?: string | null, fullSOligoBackbone?: boolean | null, otherValue?: string | null, nterminalMod?: string | null, cterminalMod?: string | null, fiveModCategory?: string | null, threeModCategory?: string | null, internalModCategory?: string | null, material?: string | null, crossContamination?: string | null, plateType?: string | null, packageType?: string | null, isoCode?: boolean | null, crRnaType?: string | null, customPeptideType?: string | null, sequenceLocation?: string | null, carrierProtein?: string | null, oligoId?: number | null, countryCode?: string | null, autoValidation?: string | null, productType?: string | null, molecularWeight?: string | null, gcContent?: string | null, meltingTemparature?: string | null, primerDimer?: string | null, secondaryStructure?: string | null, currencySymbol?: string | null, currency?: string | null, amount?: string | null, purityLevel?: string | null, quantitation?: string | null, isLabelledAminoAcid?: boolean | null, cartId?: string | null, itemId?: string | null, conjugation?: string | null, conjugationAmount?: string | null, conjugationChemistry?: string | null, additionalCarrierProtein?: string | null, additionalServices?: Array<string | null> | null, flag?: number | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null }> };

export type BiTubeDataFragment = { __typename?: 'BiTubeData', data: Array<{ __typename?: 'DuplexDetails', antisenceBaseCount?: number | null, antisenceName?: string | null, antisenceSequence?: string | null, autoGenerateOligo?: boolean | null, customerOverhang?: string | null, customerAntisenseOverHang?: string | null, antisenceThreeMod?: string | null, antisenceFiveMod?: string | null, id?: string | null, oligoId?: number | null, name?: string | null, sequence?: string | null, baseCount?: number | null, threeMod?: string | null, fiveMod?: string | null, format?: string | null, purification?: string | null, concentration?: string | null, countryCode?: string | null, productType?: string | null, scale?: string | null, price?: string | null, tubes?: string | null, autoValidation?: string | null, comments?: string | null, additionalComments?: string | null, applyToAll?: boolean | null, isOverridden?: boolean | null, orderItemId?: string | null, amount?: string | null, senseNameCheck?: boolean | null, cartId?: string | null, itemId?: string | null, currencySymbol?: string | null, currency?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null }> };

export type PlatesDataFragment = { __typename?: 'PlatesData', data: Array<{ __typename?: 'Plates', isCSR?: boolean | null, isCSRSupervisor?: boolean | null, wellType?: number | null, plateName?: string | null, researcher?: string | null, channelType?: number | null, plateType?: string | null, countryCode?: string | null, totalBaseCount?: number | null, plateId?: number | null, countOfWells?: number | null, material?: string | null, isAmountSelected?: boolean | null, isConcentrationSelected?: boolean | null, purification?: string | null, format?: string | null, concentration?: string | null, amount?: string | null, scale?: string | null, daughterPlateCount?: string | null, isOverridden?: boolean | null, isSpecificationsOverridden?: boolean | null, isShippingOverridden?: boolean | null, isPackageTypeOther?: boolean | null, minAmount?: string | null, maxAmount?: string | null, plateCopiesRange?: string | null, pageNo?: number | null, applyToAll?: boolean | null, researcherNameError?: Array<string | null> | null, plateNameError?: Array<string | null> | null, category?: string | null, packageType?: string | null, shipping?: string | null, stockPlate?: string | null, selectedPackageType?: string | null, productType?: string | null, isConcentrationOther?: boolean | null, wellList: Array<{ __typename?: 'Welllist', id?: number | null, oligoId?: number | null, name?: string | null, wellType?: number | null, mixed?: number | null, sequence?: string | null, baseCount?: number | null, threeMod?: string | null, fiveMod?: string | null, format?: string | null, other?: string | null, purification?: string | null, concentration?: string | null, scale?: string | null, countryCode?: string | null, productType?: string | null, technicalSequence?: string | null, amount?: string | null, tubes?: number | null, terms?: boolean | null, flag?: number | null, row?: string | null, column?: string | null, comments?: string | null, additionalComments?: string | null, isOverridden?: boolean | null, orderItemId?: string | null, pageNo?: number | null, packageType?: string | null, shipping?: string | null, excessMaterial?: boolean | null, molecularWeight?: string | null, primerDimer?: string | null, secondaryStructure?: string | null, gcContent?: string | null, meltingTemparature?: string | null, epsilon?: number | null, price?: string | null, priceHeaderError?: string | null, currency?: string | null, currencySymbol?: string | null, additionalServices?: Array<string | null> | null, listAdditionalServices?: Array<string | null> | null, listNgso?: Array<string | null> | null, ngsoType?: string | null, listISO?: Array<string | null> | null, crossContamination?: string | null, qualitySystem?: string | null, certificateOfAnalysis?: string | null, analyticalHPLC?: string | null, category?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarning?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null }>, biTubeWellList?: Array<{ __typename?: 'BiTubeWellList', antisenceBaseCount?: number | null, antisenceName?: string | null, antisenceSequence?: string | null, autoGenerateOligo?: boolean | null, customerOverhang?: string | null, customerAntisenseOverHang?: string | null, antisenceFiveMod?: string | null, antisenceThreeMod?: string | null, id?: number | null, name?: string | null, sequence?: string | null, baseCount?: number | null, threeMod?: string | null, fiveMod?: string | null, format?: string | null, purification?: string | null, concentration?: string | null, countryCode?: string | null, productType?: string | null, scale?: string | null, tubes?: number | null, autoValidation?: boolean | null, comments?: string | null, additionalComments?: string | null, isOverridden?: boolean | null, orderItemId?: string | null, amount?: string | null, senseNameCheck?: boolean | null, row: string, column: string, technicalAntisenceSequence?: string | null, technicalSequence?: string | null, pageNo?: number | null, packageType?: string | null, shipping?: string | null, terms?: boolean | null, molecularWeight?: string | null, primerDimer?: string | null, secondaryStructure?: string | null, gcContent?: string | null, meltingTemparature?: string | null, antisenseMolecularWeight?: string | null, antisensePrimerDimer?: string | null, antisenseMeltingTemparature?: string | null, antisenseGcContent?: string | null, antisenseSecondaryStructure?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarning?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null }> };

export type PlatesPriceResponseFragment = { __typename?: 'PlatesPriceResponse', response?: Array<{ __typename?: 'PlatePrice', currency?: string | null, brand?: string | null, material?: string | null, currencySymbol?: string | null, baseFee?: string | null, modificationFee?: string | null, purificationFee?: string | null, plateCopyFee?: string | null, shippingOptionFee?: string | null, remainingMaterials?: string | null, plateId?: number | null, plateName?: string | null, totalPrice?: string | null, errorType?: string | null, priceErrorHeader?: string | null, plateFee?: string | null, processFee?: string | null, wells?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null };

export type CrisprSessionResponseFragment = { __typename?: 'CrisprSessionResponse', data: Array<{ __typename?: 'CrisprSessionData', id?: number | null, isOverridden?: boolean | null, productType?: string | null, physicalMaterial?: string | null, listPhysicalMaterials?: Array<string | null> | null, listLentiviralBackbones?: Array<string | null> | null, listViralTiters?: Array<string | null> | null, listVolumes?: Array<string | null> | null, listAliquotings?: Array<string | null> | null, listVectors?: Array<string | null> | null, listAmount?: Array<string | null> | null, listSpecies?: Array<string | null> | null, listPurification?: Array<string | null> | null, listScale?: Array<string | null> | null, listModification?: Array<string | null> | null, listStructure?: Array<string | null> | null, lentiviralBackbone?: string | null, vector?: string | null, viralTiter?: string | null, volume?: string | null, aliquoting?: string | null, amount?: string | null, pageNo?: number | null, scale?: string | null, purification?: string | null, format?: string | null, modification?: string | null, species?: string | null, structure?: string | null, price?: string | null, currencySymbol?: string | null, currency?: string | null, terms?: boolean | null, material?: string | null, cartId?: string | null, itemId?: string | null, modifiedSequence?: string | null, modifiedTechnicalSequence?: string | null, mergedSession?: boolean | null, listSubModels?: Array<{ __typename?: 'ListSubModel', name?: string | null, geneId?: string | null, geneSymbol?: string | null, sequence?: string | null, id?: number | null, isOverridden?: boolean | null, isCurrentForm?: boolean | null, baseCount?: number | null, price?: string | null, cartId?: string | null, itemId?: string | null, listSubModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null }> };

export type CrisprPriceResponseFragment = { __typename?: 'CrisprPriceResponse', response?: Array<{ __typename?: 'CrisprPrice', currencySymbol?: string | null, price?: string | null, currency?: string | null, brand?: string | null, material?: string | null, listSubModels?: Array<{ __typename?: 'ListSubModel', price?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null };

export type AntiseraSessionDataResponseFragment = { __typename?: 'AntiseraSessionDataResponse', antiseraData?: Array<{ __typename?: 'AntiseraSessionData', id?: string | null, oligoId?: number | null, name?: string | null, countryCode?: string | null, productType?: string | null, projectName?: string | null, animalType?: string | null, numberOfAnimals?: string | null, immunizationTerm?: string | null, elisaAnalysis?: string | null, columnConstruction?: string | null, noOfColumns?: string | null, purificationOption?: string | null, purificationType?: string | null, absorptionType?: string | null, purificationColumn?: string | null, numberOfPeptides?: string | null, firstName?: string | null, lastName?: string | null, orgName?: string | null, email?: string | null, phone?: string | null, projectType?: string | null, peptide?: string | null, purificationColQuantity?: string | null, absorption?: string | null, absorptionColQuantity?: string | null, absorptionColumn?: string | null, additionalServices?: Array<string | null> | null, comments?: string | null, listAntigenForColumn?: Array<Array<string | null> | null> | null, applyToAll?: boolean | null, cartId?: string | null, itemId?: string | null, currency?: string | null, currencySymbol?: string | null, price?: string | null, projectBaseFee?: string | null, elisaFee?: string | null, colConstructionFee?: string | null, purificationFee?: string | null, adsorptionFee?: string | null, subtotal?: string | null, listAntiseraPeptideModel: Array<{ __typename?: 'AntiseraPeptideModelResponse', peptideName?: string | null, id?: string | null, amount?: string | null, sequence?: string | null, baseCount?: number | null, nterminalMod?: string | null, cterminalMod?: string | null, purityLevel?: string | null, peptideCarrierProtein?: string | null, peptideAddSpecification?: string | null, terms?: boolean | null, projectType?: string | null, listPeptideCarrierProtein?: Array<string | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null>, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null };

export type MilliplexSessionDataResponseFragment = { __typename?: 'MilliplexSessionDataResponse', milliplexData?: Array<{ __typename?: 'MilliplexSessionData', priceHeaderError?: string | null, currencySymbol?: string | null, brand?: string | null, currency?: string | null, sensitivity?: string | null, analytes?: Array<string | null> | null, mapMates?: string | null, errors?: Array<string | null> | null, species?: string | null, platform?: string | null, singlePlexPlatform?: Array<string | null> | null, researchAreas?: Array<string | null> | null, sampleVolume?: Array<string | null> | null, attributes?: Array<string | null> | null, checkedProductIdList?: Array<string | null> | null, productType?: string | null, milliplexcheckedProductIdList?: Array<string | null> | null, oligoId?: number | null, id?: number | null, listMilliplexAssayModel?: Array<{ __typename?: 'MilliplexSearchResponse', requestDate?: string | null, responseDate?: string | null, count?: number | null, version?: string | null, term?: Array<string | null> | null, termCount?: string | null, assays?: Array<{ __typename?: 'KitsItem', panelId?: string | null, panelName?: string | null, assayType?: string | null, customPremixedAvailable?: Array<string | null> | null, requireSample?: string | null, researchAreaOracle?: Array<string | null> | null, species?: string | null, researchAreas?: Array<string | null> | null, type?: string | null, listSampleType?: Array<string | null> | null, customPremixSelection?: string | null, spaceSaverSelection?: string | null, decisionTableVer?: string | null, listAnalytes?: Array<string | null> | null, selectedAnalytes?: Array<string | null> | null, price?: string | null, allAnalytesSelected?: string | null, mutualAnalytesList?: Array<Array<string | null> | null> | null, analytes?: Array<string | null> | null, quantity?: string | null, material?: string | null, spaceSaver?: string | null, name?: string | null, sampleType?: string | null, id?: number | null, productTotal?: string | null, listSearchResultModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarnings?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type SimpleAntiseraSessionResponseFragment = { __typename?: 'SimpleAntiseraSessionResponse', simpleAntiseraData?: Array<{ __typename?: 'SimpleAntiseraSessionData', id?: string | null, oligoId?: number | null, name?: string | null, countryCode?: string | null, productType?: string | null, projectName?: string | null, animalType?: string | null, numberOfAnimals?: string | null, immunizationTerm?: string | null, elisaAnalysis?: string | null, columnConstruction?: string | null, noOfColumns?: string | null, purificationType?: string | null, purificationColumn?: string | null, additionalServices?: Array<string | null> | null, purificationOption?: string | null, listAntigenForColumn?: Array<Array<string | null> | null> | null, comments?: string | null, currencySymbol?: string | null, price?: string | null, currency?: string | null, projectBaseFee?: string | null, elisaFee?: string | null, colConstructionFee?: string | null, purificationFee?: string | null, subtotal?: string | null, numberOfPeptides?: string | null, cartId?: string | null, itemId?: string | null, listAntiseraPeptideModel?: Array<{ __typename?: 'AntiseraPeptideModelResponse', peptideName?: string | null, id?: string | null, amount?: string | null, sequence?: string | null, baseCount?: number | null, nterminalMod?: string | null, cterminalMod?: string | null, purityLevel?: string | null, peptideCarrierProtein?: string | null, peptideAddSpecification?: string | null, terms?: boolean | null, projectType?: string | null, listPeptideCarrierProtein?: Array<string | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null };

export type NgsoPriceResponseFragment = { __typename?: 'NgsoPriceResponse', response?: Array<{ __typename?: 'NgsoPlatePrice', countryCode?: string | null, productType?: string | null, plateId?: number | null, material?: string | null, pageNo?: number | null, wellList?: Array<{ __typename?: 'WellListPrice', id?: number | null, oligoId?: number | null, name?: string | null, sequence?: string | null, baseCount?: string | null, shipping?: string | null, priceHeaderError?: string | null, price?: string | null, currencySymbol?: string | null, currency?: string | null, formattedPrice?: string | null, brand?: string | null, material?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null };

export const TubeDataFromSessionFragmentDoc = gql`
    fragment TubeDataFromSession on TubeDataFromSession {
  data {
    isOverridden
    name
    sequence
    minimumYield
    epsilon
    fiveMod
    threeMod
    internalMod
    probeType
    purification
    baseCount
    format
    scale
    concentration
    tubes
    price
    orderItemId
    id
    applyToAll
    comments
    additionalComments
    fullSOligoBackbone
    otherValue
    nterminalMod
    cterminalMod
    fiveModCategory
    threeModCategory
    internalModCategory
    material
    crossContamination
    plateType
    packageType
    isoCode
    crRnaType
    customPeptideType
    sequenceLocation
    carrierProtein
    oligoId
    countryCode
    autoValidation
    productType
    molecularWeight
    gcContent
    meltingTemparature
    primerDimer
    secondaryStructure
    currencySymbol
    currency
    amount
    purityLevel
    quantitation
    isLabelledAminoAcid
    listError {
      key
      value
    }
    cartId
    itemId
    conjugation
    conjugationAmount
    conjugationChemistry
    additionalCarrierProtein
    additionalServices
    flag
  }
}
    `;
export const BiTubeDataFragmentDoc = gql`
    fragment BiTubeData on BiTubeData {
  data {
    antisenceBaseCount
    antisenceName
    antisenceSequence
    autoGenerateOligo
    customerOverhang
    customerAntisenseOverHang
    antisenceThreeMod
    antisenceFiveMod
    id
    oligoId
    name
    sequence
    baseCount
    threeMod
    fiveMod
    format
    purification
    concentration
    countryCode
    productType
    scale
    price
    tubes
    autoValidation
    comments
    additionalComments
    applyToAll
    isOverridden
    orderItemId
    amount
    senseNameCheck
    listError {
      key
      value
    }
    cartId
    itemId
    currencySymbol
    currency
  }
}
    `;
export const PlatesDataFragmentDoc = gql`
    fragment PlatesData on PlatesData {
  data {
    isCSR
    isCSRSupervisor
    wellType
    plateName
    researcher
    channelType
    plateType
    countryCode
    totalBaseCount
    plateId
    countOfWells
    material
    isAmountSelected
    isConcentrationSelected
    purification
    format
    concentration
    amount
    scale
    daughterPlateCount
    isOverridden
    isSpecificationsOverridden
    isShippingOverridden
    isPackageTypeOther
    minAmount
    maxAmount
    plateCopiesRange
    pageNo
    applyToAll
    researcherNameError
    plateNameError
    category
    packageType
    shipping
    stockPlate
    selectedPackageType
    productType
    isConcentrationOther
    wellList {
      id
      oligoId
      name
      wellType
      mixed
      sequence
      baseCount
      threeMod
      fiveMod
      format
      other
      purification
      concentration
      scale
      countryCode
      productType
      technicalSequence
      amount
      tubes
      terms
      flag
      row
      column
      comments
      additionalComments
      isOverridden
      orderItemId
      pageNo
      packageType
      shipping
      excessMaterial
      molecularWeight
      primerDimer
      secondaryStructure
      gcContent
      meltingTemparature
      epsilon
      price
      priceHeaderError
      currency
      currencySymbol
      additionalServices
      listAdditionalServices
      listNgso
      ngsoType
      listISO
      crossContamination
      qualitySystem
      certificateOfAnalysis
      analyticalHPLC
      listError {
        key
        value
      }
      listWarning {
        key
        value
      }
      category
    }
    biTubeWellList {
      antisenceBaseCount
      antisenceName
      antisenceSequence
      autoGenerateOligo
      customerOverhang
      customerAntisenseOverHang
      antisenceFiveMod
      antisenceThreeMod
      id
      name
      sequence
      baseCount
      threeMod
      fiveMod
      format
      purification
      concentration
      countryCode
      productType
      scale
      tubes
      autoValidation
      comments
      additionalComments
      isOverridden
      orderItemId
      amount
      senseNameCheck
      row
      column
      technicalAntisenceSequence
      technicalSequence
      pageNo
      packageType
      shipping
      terms
      molecularWeight
      primerDimer
      secondaryStructure
      gcContent
      meltingTemparature
      antisenseMolecularWeight
      antisensePrimerDimer
      antisenseMeltingTemparature
      antisenseGcContent
      antisenseSecondaryStructure
      listError {
        key
        value
      }
      listWarning {
        key
        value
      }
    }
  }
}
    `;
export const PlatesPriceResponseFragmentDoc = gql`
    fragment PlatesPriceResponse on PlatesPriceResponse {
  response {
    currency
    brand
    material
    currencySymbol
    baseFee
    modificationFee
    purificationFee
    plateCopyFee
    shippingOptionFee
    remainingMaterials
    plateId
    plateName
    totalPrice
    errorType
    priceErrorHeader
    plateFee
    processFee
    wells
  }
  serverError {
    key
    value
  }
}
    `;
export const CrisprSessionResponseFragmentDoc = gql`
    fragment CrisprSessionResponse on CrisprSessionResponse {
  data {
    id
    isOverridden
    productType
    physicalMaterial
    listPhysicalMaterials
    listLentiviralBackbones
    listViralTiters
    listVolumes
    listAliquotings
    listVectors
    listAmount
    listSpecies
    listPurification
    listScale
    listModification
    listStructure
    lentiviralBackbone
    vector
    viralTiter
    volume
    aliquoting
    amount
    pageNo
    scale
    purification
    format
    modification
    species
    structure
    price
    currencySymbol
    currency
    terms
    listSubModels {
      name
      geneId
      geneSymbol
      sequence
      id
      isOverridden
      isCurrentForm
      baseCount
      price
      cartId
      itemId
      listSubModelErrors {
        key
        value
      }
    }
    material
    cartId
    itemId
    modifiedSequence
    modifiedTechnicalSequence
    mergedSession
  }
}
    `;
export const CrisprPriceResponseFragmentDoc = gql`
    fragment CrisprPriceResponse on CrisprPriceResponse {
  response {
    currencySymbol
    price
    currency
    brand
    material
    listSubModels {
      price
    }
  }
  serverError {
    key
    value
  }
}
    `;
export const AntiseraSessionDataResponseFragmentDoc = gql`
    fragment AntiseraSessionDataResponse on AntiseraSessionDataResponse {
  antiseraData {
    id
    oligoId
    name
    countryCode
    productType
    projectName
    animalType
    numberOfAnimals
    immunizationTerm
    elisaAnalysis
    columnConstruction
    noOfColumns
    purificationOption
    purificationType
    absorptionType
    purificationColumn
    listAntiseraPeptideModel {
      peptideName
      id
      amount
      sequence
      baseCount
      nterminalMod
      cterminalMod
      purityLevel
      peptideCarrierProtein
      peptideAddSpecification
      terms
      projectType
      listPeptideCarrierProtein
      listError {
        key
        value
      }
    }
    numberOfPeptides
    firstName
    lastName
    orgName
    email
    phone
    listError {
      key
      value
    }
    projectType
    peptide
    purificationColQuantity
    absorption
    absorptionColQuantity
    absorptionColumn
    additionalServices
    comments
    listAntigenForColumn
    applyToAll
    cartId
    itemId
    currency
    currencySymbol
    price
    projectBaseFee
    elisaFee
    colConstructionFee
    purificationFee
    adsorptionFee
    subtotal
  }
}
    `;
export const MilliplexSessionDataResponseFragmentDoc = gql`
    fragment MilliplexSessionDataResponse on MilliplexSessionDataResponse {
  milliplexData {
    priceHeaderError
    currencySymbol
    brand
    currency
    sensitivity
    analytes
    mapMates
    errors
    species
    platform
    singlePlexPlatform
    researchAreas
    sampleVolume
    attributes
    checkedProductIdList
    productType
    platform
    milliplexcheckedProductIdList
    listMilliplexAssayModel {
      requestDate
      responseDate
      count
      version
      term
      termCount
      assays {
        panelId
        panelName
        assayType
        customPremixedAvailable
        requireSample
        researchAreaOracle
        species
        researchAreas
        type
        listSampleType
        customPremixSelection
        spaceSaverSelection
        decisionTableVer
        listSearchResultModelErrors {
          key
          value
        }
        listWarnings {
          key
          value
        }
        listAnalytes
        selectedAnalytes
        price
        allAnalytesSelected
        mutualAnalytesList
        analytes
        quantity
        material
        spaceSaver
        name
        sampleType
        id
        productTotal
      }
    }
    oligoId
    id
  }
}
    `;
export const SimpleAntiseraSessionResponseFragmentDoc = gql`
    fragment SimpleAntiseraSessionResponse on SimpleAntiseraSessionResponse {
  simpleAntiseraData {
    id
    oligoId
    name
    countryCode
    productType
    projectName
    animalType
    numberOfAnimals
    immunizationTerm
    elisaAnalysis
    columnConstruction
    listAntiseraPeptideModel {
      peptideName
      id
      amount
      sequence
      baseCount
      nterminalMod
      cterminalMod
      purityLevel
      peptideCarrierProtein
      peptideAddSpecification
      terms
      projectType
      listPeptideCarrierProtein
      listError {
        key
        value
      }
    }
    listError {
      key
      value
    }
    noOfColumns
    purificationType
    purificationColumn
    additionalServices
    purificationOption
    listAntigenForColumn
    comments
    currencySymbol
    price
    currency
    projectBaseFee
    elisaFee
    colConstructionFee
    purificationFee
    subtotal
    numberOfPeptides
    cartId
    itemId
  }
}
    `;
export const NgsoPriceResponseFragmentDoc = gql`
    fragment NgsoPriceResponse on NgsoPriceResponse {
  response {
    countryCode
    productType
    plateId
    material
    pageNo
    wellList {
      id
      oligoId
      name
      sequence
      baseCount
      shipping
      priceHeaderError
      price
      currencySymbol
      currency
      formattedPrice
      brand
      material
    }
  }
  serverError {
    key
    value
  }
}
    `;